import { ParsedUrlQuery } from 'querystring';

import moment from 'moment';

import { callService } from '@api/caller';

import { LocationType } from '../constants';

// ================================================
// Fetch locations and fill the search by location
// ================================================
export const fetchLocationsItems = async (searchText: string) => {
  return await callService('SearchesService', 'searchVehicle', {
    s: searchText,
  });
};

export const isPickUpLocation = (type: LocationType) =>
  type === LocationType.PICK_UP;

export const generateSearchQuery = (
  existingQuery: ParsedUrlQuery,
  queryKey: string,
  value?: string
): void => {
  if (value) {
    existingQuery[queryKey] = value;
  } else {
    delete existingQuery[queryKey];
  }
};

/**
 * @description Generates a date time query string
 * @param date string   2023-05-29
 * @param time string   20:20
 * @returns string     2023-05-29T20:20:00
 */
export const generateDateTimeQuery = (date, time) => {
  const dateTime = `${date}T${time}:00`;
  return dateTime;
};

interface ICheckSameOrGreaterDateTimeByTime {
  /**
   * @example isPickUpTime = true
   */
  isPickUpTime: boolean;

  /**
   * @example newTimeValue = 20:00
   */
  newTimeValue: string;

  /**
   * @example pickUpDate = 2023-05-29
   */
  pickUpDate: string;

  /**
   * @example pickUpTime = 20:00
   */
  pickUpTime: string;

  /**
   * @example dropOffDate = 2023-05-29
   */
  dropOffDate: string;

  /**
   * @example dropOffTime = 20:00
   */
  dropOffTime: string;
}

/**
 * @description Checks if the new time value is same or greater than the other date time
 */
export const checkSameOrGreaterDateTimeByTime = ({
  isPickUpTime,
  newTimeValue,
  pickUpDate,
  pickUpTime,
  dropOffDate,
  dropOffTime,
}: ICheckSameOrGreaterDateTimeByTime): boolean => {
  const pickUpDateTime = moment(pickUpDate).set(
    isPickUpTime
      ? {
          hour: parseInt(newTimeValue.split(':')[0]),
          minute: parseInt(newTimeValue.split(':')[1]),
        }
      : {
          hour: parseInt(pickUpTime.split(':')[0]),
          minute: parseInt(pickUpTime.split(':')[1]),
        }
  );
  const dropOffDateTime = moment(dropOffDate).set(
    !isPickUpTime
      ? {
          hour: parseInt(newTimeValue.split(':')[0]),
          minute: parseInt(newTimeValue.split(':')[1]),
        }
      : {
          hour: parseInt(dropOffTime.split(':')[0]),
          minute: parseInt(dropOffTime.split(':')[1]),
        }
  );

  return pickUpDateTime?.isSameOrAfter(dropOffDateTime);
};

export const getSearchParamAsNumber = (
  param: string | string[] | undefined,
  defaultValue: number
): number => {
  if (param) {
    const value = Array.isArray(param) ? param[0] : param;
    const num = parseInt(value, 10);
    return !isNaN(num) ? num : defaultValue;
  }

  return defaultValue;
};
